const prefix = 'report-incomplete-projects';

const SET_PROJECTS = `${prefix}/SET_PROJECTS`;

const SET_LOADING = `${prefix}/SET_LOADING`;

const RESET = `${prefix}/RESET`;

export { SET_PROJECTS, RESET, SET_LOADING };
